import useEventContext from '@hooks/useEventContext';
import { Button, Fade, Grid2 as Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import EventGeneralInfo from './EventGeneralInfo';
import PaymentStatusBanner from '@components/JoinEvent/PaymentStatusBanner';

export default function EventOverview({ previewOnly = false }: { previewOnly?: boolean }) {
    const { event } = useEventContext();
    const navigate = useNavigate();

    return event ? (
        <Grid marginX={'auto'} maxWidth={1200} paddingY={'1vh'}>
            {/* <EventPaymentStatus event={event} membership={membership} /> */}
            <PaymentStatusBanner />

            <EventGeneralInfo event={event} previewOnly={previewOnly} />
        </Grid>
    ) : (
        // Fade in error message if event is not found
        <Fade in={true} timeout={1500} unmountOnExit>
            <Grid
                marginX={'auto'}
                maxWidth={1000}
                m="5rem"
                display="flex"
                flexDirection="column"
                alignItems="center"
            >
                <Typography variant="h5">Error loading this event</Typography>
                <Typography variant="h5" m="2rem">
                    We may be still confirming this event, or your url is bad, please check back
                    later.
                </Typography>
                <Button onClick={() => navigate('/events')} variant="contained">
                    Back to Events
                </Button>
            </Grid>
        </Fade>
    );
}
